import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import GoPropertiesCls from './GoPropertiesCls';
import { OrbUserContext } from '../OrbUserContext';

export interface IGoPropertiesProps extends IUseApiProps, IWithErrorHandlingProps {
}

const GoProperties = (props: IGoPropertiesProps) => {
    const { userPermissions, orbConfig } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <GoPropertiesCls
                userPermissions={userPermissions}
                orbConfig={orbConfig}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(GoProperties);
